import { UPDATE_ADMIN_STATUS } from "../actions";

const defaultState = {
    isAdmin: false
}

const adminReducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_ADMIN_STATUS:
            return {
                ...state,
                isAdmin: action.payload.isAdmin
            }
        default: return state
    }
}

export default adminReducer;